import React, { useEffect, useState } from "react";
import SectionContainer from "../../../Homepage/SectionContainer";
import { Col, Container, Row } from "reactstrap";

import banner from "../../../assets/kangaroo/ieltsprep.png";

import { useLocation, useNavigate } from "react-router-dom";
import FormGoldBg from "../../../component/FormCloseGold/FormGoldBg";
import BreadCrumb from "../../../component/BreadCrumb/BreadCrumb";
import InlineForm from "../../../component/InlineForm/InlineForm";
import DynamicInlineForm from "../../../component/DynamicInline/DynamicInlineForm";
import axios from "axios";
import TestPreparationService from "../../../services/TespreparationService";
import { useQuery } from "@tanstack/react-query";
import { imageBaseApi } from "../../../services/imageBaseApi";
import PageService from "../../../services/PageService";
import WidgetsService from "../../../services/WidgetsService";

const TestPreparation = () => {


  const { pathname } = useLocation();
  const slug = pathname.split("/").filter(Boolean).pop();

  const widgetType = slug === "test-preparation" ? 2 : slug === "travel" ? 3 : 4;

  console.log("🚀 ~ TestPreparation ~ slug:", slug)
  // const slug = "etst"

  const fetchTestPreparation = async (slug) => {
    const response = await PageService.getbySlug(slug)
    return response;
  };

  const { data: testPrepData } = useQuery({
    queryKey: ["test-preparationss", slug],
    queryFn: () => fetchTestPreparation(slug),

  });

  const fetchWidgets = async () => {
    const response = await WidgetsService.getHomeWidgets(widgetType);
    return response
  }

  const { data: WidgetData, isPending: WidgetPending, error: WidgetError } = useQuery({
    queryKey: ['WidgetData', widgetType],
    queryFn: fetchWidgets,
  })

  const renderWidgetContent = (htmlContent) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;

    return Array.from(tempDiv.children).map((child, index) => {
      if (child.tagName === "H1") {
        return (
          <Row key={index} >
            <Col>
              <h1 className="font-level-4 lh-1" style={{ marginTop: "2rem" }}>{child.textContent}</h1>
            </Col>
          </Row>
        );
      }

      if (child.tagName === "H2") {
        return (
          <Row key={index} >
            <Col>
              <h1 className="font-level-8" style={{ marginTop: "2rem" }}>{child.textContent}</h1>
            </Col>
          </Row>
        );
      }

      if (child.tagName === "H3") {
        return (
          <Row key={index} >
            <Col>
              <h1 className="font-level-7" style={{ marginTop: "2rem" }}>{child.textContent}</h1>
            </Col>
          </Row>
        );
      }



      if (child.tagName === "P" && child.textContent.trim()) {
        return (
          <Row key={index}>
            <Col>
              <p
                className="country-paragraph-text mb-3"
                dangerouslySetInnerHTML={{
                  __html: child.innerHTML,
                }}
              />
            </Col>
          </Row>
        );
      }

      if (child.tagName === "UL") {
        return (
          <Row key={index}>
            <Col>
              <ul
                className="country-paragraph-text mb-3"
                dangerouslySetInnerHTML={{
                  __html: child.innerHTML,
                }}
              />
            </Col>
          </Row>
        );
      }

      if (child.tagName === "OL") {
        return (
          <Row key={index}>
            <Col>
              <ol
                className="country-paragraph-text mb-3"
                dangerouslySetInnerHTML={{
                  __html: child.innerHTML,
                }}
              />
            </Col>
          </Row>
        );
      }

      return null;
    });
  };


  const renderContent = (htmlContent) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;

    return Array.from(tempDiv.children).map((child, index) => {
      if (child.tagName === "H1") {
        return <h1 key={index} className="font-level-4 mt-4">{child.textContent}</h1>;
      }

      if (child.tagName === "H2") {
        return <h2 key={index} className="font-level-8 mt-4">{child.textContent}</h2>;
      }

      if (child.tagName === "H3") {
        return <h3 key={index} className="font-level-8 mt-4">{child.textContent}</h3>;
      }

      if (child.tagName === "H4") {
        return <h4 key={index} className="font-level-7 mt-4">{child.textContent}</h4>;
      }

      if (child.tagName === "P") {
        return (
          <p
            key={index}
            className="country-paragraph-text mb-3"
            dangerouslySetInnerHTML={{ __html: child.innerHTML }}
          />
        );
      }

      if (child.tagName === "UL") {
        return (
          <ul
            key={index}
            className="country-paragraph-text mb-3"
            dangerouslySetInnerHTML={{ __html: child.innerHTML }}
          />
        );
      }

      if (child.tagName === "OL") {
        return (
          <ol
            key={index}
            className="country-paragraph-text mb-3"
            dangerouslySetInnerHTML={{ __html: child.innerHTML }}
          />
        );
      }

      if (child.tagName === "FIGURE" && child.querySelector("table")) {
        return (
          <div key={index} className="table-responsive my-4">
            <table
              className="table table-bordered"
              dangerouslySetInnerHTML={{
                __html: child.querySelector("table").innerHTML,
              }}
            />
          </div>
        );
      }

      if (child.tagName === "FIGURE" && child.querySelector("img")) {
        const img = child.querySelector("img");
        const src = img.getAttribute("src");

        // Skip images without src
        if (!src) return null;

        return (
          <div key={index} style={{ height: "400px", width: "100%" }}>
            <img
              src={src}
              alt={img.getAttribute("alt") || ""}
              className="img-fluid w-100 h-100"
              style={{ objectFit: "contain" }}
            />
          </div>
        );
      }


      return null;
    });
  };



  return (
    <>
      <div
        className="hero-banner"
        style={{
          "--banner-img": `url(${testPrepData?.featuredMedia
            ? `${imageBaseApi}${testPrepData?.featuredMedia?.url}`
            : banner
            })`,
          overflow: "hidden",
          height: "300px",

        }}
      >
        <SectionContainer>
          <Container fluid className="p-0 m-0">
            <BreadCrumb
              items={[
                { title: "HOME", link: "/" },
                { title: testPrepData?.title.toUpperCase() },
              ]}
              instituition={false}

            />
          </Container>
        </SectionContainer>
      </div>
      <SectionContainer>

        <Row className="mb-0">
          <Col>
            {testPrepData?.content && renderContent(testPrepData?.content)}
          </Col>
        </Row>

        <div className="mb-5">

          {WidgetData?.map((widget) => renderWidgetContent(widget?.widget?.description))}
        </div>






      </SectionContainer>


    </>
  );
};

export default TestPreparation;
